<template>
  <div class="flex flex-col h-screen">
    <PortalAppBanner
      v-if="page.props.show_portal_app_banner"
      :portalAppBanner="page.props.portal_app_banner"
    />
    <div class="flex flex-1 overflow-hidden">
      <div class="flex flex-col flex-1 overflow-y-scroll bg-gray-100 lg:w-2/3">
        <main class="self-center w-full p-2 my-auto sm:p-4 md:p-12 lg:p-20">
          <Stack space="large" align="stretch">
            <Card has-border has-shadow is-rounded is-padded class="w-full max-w-lg mx-auto">
              <Box padding-y="large">
                <Stack v-if="renderDefaultPageWrapper">
                  <Stack align="center" space="small">
                    <a
                      v-if="tenant.theme.logo_url"
                      :href="tenant.theme.website_url ?? '#'"
                      target="_blank"
                    >
                      <img class="w-auto h-14" :src="tenant.theme.logo_url" alt="Logo Image" />
                    </a>
                    <Logo v-else :name="tenant.company.name" size="medium" :hasShadow="false" />

                    <Typography v-if="title" variant="h1" class="text-center">
                      {{ title }}
                    </Typography>
                    <Typography v-if="description" as="p" class="text-center text-balance">
                      {{ description }}
                    </Typography>
                  </Stack>
                  <slot />
                </Stack>
                <slot v-else />
              </Box>
            </Card>
            <PoweredByAryeo v-if="tenant.company.has_aryeo_branding" color="body" />
          </Stack>
        </main>
      </div>
      <div class="w-0 h-screen lg:w-1/3">
        <img
          class="object-cover w-full h-full opacity-90"
          :src="tenant.theme.cover_url"
          alt="Cover Image"
        />
      </div>
    </div>
    <FlashMessage />

    <GoogleTagManagerScripts
      v-if="tenant.company.google_tag_manager_id"
      :googleTagManagerId="tenant.company.google_tag_manager_id"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Logo, Stack, Card, Box, Typography } from '@aryeo/runway'
import { useTenant } from '@/Hooks/Shared/useTenant'
import { usePage } from '@inertiajs/vue3'

import FlashMessage from '@/Components/Shared/FlashMessage.vue'
import GoogleTagManagerScripts from '@/Components/Customer/OrderForms/LayoutParts/GoogleTagManagerScripts.vue'
import PortalAppBanner from '@/Components/Shared/PortalAppBanner.vue'
import PoweredByAryeo from '@/Components/Shared/Global/PoweredByAryeo.vue'

const { tenant } = useTenant()

const page = usePage()

const renderDefaultPageWrapper = computed(() => page.props.meta?.renderDefaultPageWrapper ?? true)
const title = computed(() => page.props.meta.title)
const description = computed(() => page.props.meta.description)
</script>
